import * as React from 'react';
export const paypalSvg = React.forwardRef(function paypalSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      clipRule: 'evenodd',
      d: 'm11.67 3.834.011.004a3.805 3.805 0 0 1-.011-.004Zm.411.162c.048.022.094.045.14.07.195-1.245-.002-2.093-.675-2.86C10.805.362 9.466 0 7.753 0H2.779a.71.71 0 0 0-.702.6L.005 13.732c-.04.26.16.494.422.494h3.07l.77-4.887-.023.15c.055-.346.35-.6.7-.6h1.46c2.866 0 5.11-1.165 5.765-4.531.02-.1.036-.197.051-.292a3.08 3.08 0 0 0-.139-.07Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      clipRule: 'evenodd',
      d: 'm12.348 4.504-.012-.003.012.003Zm.396.157ZM3.392 14.892h.772l.77-4.888-.023.15c.055-.346.35-.6.7-.6h1.46c2.865 0 5.11-1.164 5.765-4.53.02-.1.036-.197.05-.292a3.157 3.157 0 0 0 .001 0l.021-.143.02.022c.635.723.759 1.75.52 2.981-.575 2.946-2.537 3.964-5.045 3.964h-.387a.622.622 0 0 0-.615.526l-.031.17-.487 3.092-.026.131a.623.623 0 0 1-.615.525H3.654a.373.373 0 0 1-.368-.432l.106-.676Z',
    }),
  );
});
paypalSvg.defaultProps = {
  width: '14',
  height: '16',
  viewBox: '0 0 14 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var paypal = {
  category: 'paymentmethod',
  colorable: true,
  name: 'paypal',
  svg: paypalSvg,
};
